import React from 'react'
import { connect } from 'react-redux';
import 'moment/locale/pt-br'
import 'react-datepicker/dist/react-datepicker.css';
import buscarItinerariosEmbarque from '../../actions/itinerario/buscarItinerariosEmbarque';
import ItinerariosEncomenda from './ItinerariosEncomenda';
import {
    getAdminEmpresa,
    getFiscalEmbarque,
    getGestorEmpresa,
    getMotoristaEmpresa,
    getOperadorEmpresa,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import Autorizacao from '../../security/Autorizacao';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import { alterouFiltro, alterouPagina } from '../../util/filtros';
import PainelFiltragem from '../itinerario/PainelFiltrosItinerarioEmbarque';
import limparFiltroItinerarioEmbarque from '../../actions/itinerario/limparFiltroItinerarioEmbarque'
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PaginacaoitinerarioEmbarque from '../itinerario/PaginacaoitinerarioEmbarque';
import BotoesPaginacaoItinerarioEmbarque from '../itinerario/BotoesPaginacaoItinerarioEmbarque';
import determinarPaginaAtualItinerarioEmbarque from '../../actions/itinerario/determinarPaginaAtualItinerarioEmbarque';

export class PainelConfirmarEntregaEncomendas extends React.Component {
    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        this.props.determinarPaginaAtualItinerarioEmbarque(1);
        this.props.limparFiltroItinerarioEmbarque();
    }

    componentDidMount() {
        this.props.buscarItinerariosEmbarque(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados)
    }

    buscarItinerariosEmbarque() {
        this.props.buscarItinerariosEmbarque(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados)
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            this.props.buscarItinerariosEmbarque(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados)
            if (!alterouPagina(this.props, prevProps)) {
                this.props.determinarPaginaAtualItinerarioEmbarque(1)
            }
        }
    }

    render() {
        return (<Autorizacao perfisPermitidos={[PERFIL_ADMIN,
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getOperadorEmpresa(this.props.empresaSelecionada.id),
            getMotoristaEmpresa(this.props.empresaSelecionada.id),
            getFiscalEmbarque(this.props.empresaSelecionada.id)]}
            empresaSelecionada={this.props.empresaSelecionada}>
            <div className="col-md-12">
                <div className='col-md-12'>
                    <Titulo texto="Gerenciar itinerários com encomendas" urlRetorno="/menu-encomendas" />
                    <div className="col-12 filtro-busca">
                        <PainelFiltragem />
                    </div>
                </div>

                <div className='container-padrao mt-5'>
                    <CabecalhoRodapeTabela
                        Itinerarios={this.props.itinerarios}
                        OpcoesPaginacao={PaginacaoitinerarioEmbarque}
                        BotoesPaginacao={BotoesPaginacaoItinerarioEmbarque}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <ItinerariosEncomenda/>
                    </CabecalhoRodapeTabela>
                </div>
            </div>
        </Autorizacao>)
    }
}

export function mapStateToProps(state) {
    return {
        reservas: state.reservas,
        itinerarios: state.itinerarios.itinerarios,
        itinerarioSelecionado: state.itinerarioSelecionado,
        filtrosAdicionados: state.filtrosAdicionadosItinerarioEmbarque,
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualItinerarioEmbarque,
        registrosPorPagina: state.registrosPorPaginaAtualItinerarioEmbarque
    }
}


export default connect(mapStateToProps, {
    buscarItinerariosEmbarque,
    limparFiltroItinerarioEmbarque,
    determinarPaginaAtualItinerarioEmbarque
})(PainelConfirmarEntregaEncomendas);
